// extracted by mini-css-extract-plugin
export default {"wrapperContent":"DesignCustomization_wrapperContent__xjIN0"};